import { Controller, FieldPathByValue, FieldValues, UseControllerProps } from 'react-hook-form';
import { Role } from 'shared/types';

import { RoleAutocomplete } from '../../entitySearch';

interface ConnectedRoleAutocompleteProps<TFieldValues extends FieldValues, Multiple extends boolean = false> extends UseControllerProps<TFieldValues> {
    multiple?: Multiple;
    name: Multiple extends true ? FieldPathByValue<TFieldValues, Role[]> : FieldPathByValue<TFieldValues, Role>;
}

export default function ConnectedRoleAutocomplete<TFieldValues extends FieldValues, Multiple extends boolean = false>({
    control,
    name,
    ...rest
}: ConnectedRoleAutocompleteProps<TFieldValues, Multiple>) {
    return (
        <Controller 
            name={ name }
            control={ control }
            render={ ({ field: { ref, ...field }, fieldState }) => (
                <RoleAutocomplete<Multiple> 
                    { ...field }
                    error={ Boolean(fieldState.error?.message) }
                    helperText={ fieldState.error?.message }
                    inputRef={ ref }
                    { ...rest }
                />
            ) }
        />
    );
}
